import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-edit-user',
  templateUrl: './profile-edit-user.component.html',
  styleUrls: ['./profile-edit-user.component.scss']
})
export class ProfileEditUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
